import React, { useState } from 'react';

const SaveSixtyChip = () => {
    return (
        <span className="bg-[#FFD700] text-[#001C3D] text-xs font-semibold px-3 py-1 rounded-lg">
            Save 60%
        </span>
    );
};

const SevenDayFreeTrialChip = () => {
    return (
        <span className="bg-[#F01E6F] text-white text-xs font-semibold px-3 py-1 rounded-lg">
            7-day free trial
        </span>
    );
};


const PricingCards = ({ prices = [], onPlanChange, plan, discounts = {} }) => {
    return (
        <div className="flex flex-col gap-2 my-4 px-6">
            {prices.map(price => {
                const isSelected = plan === price.interval;
                const discount = discounts[price.interval];

                return (
                    <div
                        key={price.id}
                        className={`relative p-5 rounded-xl ${isSelected
                            ? 'bg-[#FEF6F7] border-2 border-[#F01E6F]'
                            : 'bg-[#FEF6F7] border border-gray-200'}`}
                        onClick={() => onPlanChange(price.interval)}
                    >
                        {isSelected &&
                            <div className="absolute -top-3 left-3 flex gap-1">
                                <SevenDayFreeTrialChip />
                                {price.interval === 'year' && <SaveSixtyChip />}
                            </div>}
                        <div className="flex items-center gap-3">
                            <div className={`size-5 rounded-full border-2 flex items-center justify-center
                                ${isSelected
                                    ? 'border-[#F01E6F] bg-[#F01E6F]'
                                    : 'border-gray-200'} flex-shrink-0`}>
                                {isSelected && (
                                    <div className="w-2 h-2 bg-white rounded-full m-auto">

                                    </div>
                                )}
                            </div>

                            <div className="flex-1">
                                <div className="text-lg font-semibold text-[#001C3D]">
                                    {price.interval === 'year' ? '12 months' : '1 month'}
                                </div>
                                <div className="text-xs text-[#001C3D] opacity-50">
                                    ${discount.priceAmount || price.amount} billed {price.interval === 'year'
                                        ? 'annually' : 'monthly'}
                                </div>
                            </div>

                            <div className="text-lg font-semibold text-[#001C3D]">
                                ${(discount.pricePerMonth || price.pricePerMonth).toFixed(2)}/mo
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default PricingCards; 